import React, { useContext } from 'react';

import Menu from 'src/components/Menu';
import SidebarContext from 'src/utils/context/SidebarContext';
import getEnv from 'src/utils/api/env';
// eslint-disable-next-line
import { default as data } from '../../../package.json';
import Styled from './Sidebar.styles';

const Sidebar = (props) => {
  const { setExpanded: setExpandedProp, ...rest } = props;
  const { setExpanded, expanded } = useContext(SidebarContext);

  return (
    <Styled.Sidebar expanded={expanded} {...rest}>
      <Styled.SidebarExpand
        expanded={expanded}
        id="SIDEBAR_EXPAND"
        onClick={() => {
          setExpanded(!expanded);
        }}
      />
      <Styled.SidebarLogo name={expanded ? 'eiq-lrqa-sidebar-expanded-logo': 'eiq-lrqa-sidebar-collapsed'} />
          <Styled.SidebarLogoVersion>
          {data.version} ({getEnv()})
        </Styled.SidebarLogoVersion>
      <Styled.SidebarDivider />
      <Menu expanded={expanded} {...rest} />
      <Styled.SidebarLogoVersion>
        {data.version} ({getEnv()})
      </Styled.SidebarLogoVersion>
    </Styled.Sidebar>
  );
};

export default React.memo(Sidebar);
